import * as yup from "yup";

import {
  regexText,
  regexTime,
  MAX_FILE_SIZE,
  validateIsWorkingDay,
  validateIsWorkingHours,
  validateIsDateInPast,
} from "../utils";

import type { Translate } from "@shared/i18n/translationKey";

const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const buildPostulateCandidateSchema = (t: Translate) =>
  yup
    .object()
    .shape({
      firstName: yup
        .string()
        .required(t("isRequired"))
        .max(30, t("lengthMustNotBeMoreThan30Characters"))
        .min(2, t("lengthMustNotBeGreaterThan2Characters"))
        .matches(regexText, t("itMustContainTextOnly")),
      lastName: yup
        .string()
        .required(t("isRequired"))
        .max(30, t("lengthMustNotBeMoreThan30Characters"))
        .min(2, t("lengthMustNotBeGreaterThan2Characters"))
        .matches(regexText, t("itMustContainTextOnly")),
      email: yup.string().email(t("mailValid")).required(t("isRequired")),
      interviewDateTime: yup
        .string()
        .required(t("isRequired"))
        .typeError(t("invalidDate"))
        .test("is-working-day", t("invalidWorkingDays"), validateIsWorkingDay)
        .test("is-date-in-past", t("invalidDateInPast"), validateIsDateInPast)
        .test("is-working-hours", t("invalidWorkingHours"), validateIsWorkingHours),
      interviewDay: yup.string().required(t("isRequired")),
      interviewHour: yup
        .string()
        .required(t("isRequired"))
        .matches(regexTime, t("pleaseEnterValidTime")),
      cover: yup
        .mixed()
        .required(t("isRequired"))
        .test("file-size", t("maximumFileSizeInvoice"), (value) => {
          if (!value) return false;
          return (value as File).size <= MAX_FILE_SIZE;
        })
        .test("file-type", t("allowedFormatInvoice"), (value) => {
          if (!value) return false;
          return ALLOWED_FILE_TYPES.includes((value as File).type);
        }),
    })
    .required();
